/* eslint-disable @typescript-eslint/no-explicit-any */

import type { BaseErrorResponse, GetTransactionLogRes } from './data-contracts';
import type { RequestParams } from './http-client';
import { HttpClient } from './http-client';


export default function useTransactionLog() {
  class TransactionLog<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Transaction log
     * @name TransactionLogControllerGetTransactionLog
     * @summary Returns transaction log
     * @request GET:/api3/transaction-log
     * @secure
     * @response `200` `GetTransactionLogRes`
     * @response `400` `BaseErrorResponse`
     */
    transactionLogControllerGetTransactionLog = (
      query: {
        /**
         * @min 1
         * @max 500
         * @example 10
         */
        limit: number;
        /**
         * @min 0
         * @example 0
         */
        page: number;
        /** @example 1 */
        accountId?: any;
        /** @example 1 */
        positionId?: any;
        /** @example "Purchase" */
        documentType?: string;
        /** @example 1 */
        docId?: any;
        /** @example "PV" */
        planProperty?: string;
        /** @example 1 */
        periodId?: any;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetTransactionLogRes, BaseErrorResponse>({
        path: '/api3/transaction-log',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new TransactionLog();
}
